import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { IconExternal } from '@zillow/constellation';

import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

import {
    GA_EVENTS,
    GA_PREFIX,
} from 'app/shared/constants/AnalyticsListingModuleConstants';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import propertyUtils from 'app/shared/utils/propertyUtils';
import stringHelper from 'app/shared/utils/stringHelper';

import {
    StyledCompsComponent,
    StyledText,
    StyledTextButton,
    StyledCompsSummaryContainer,
} from './StyledComponents';

const pmrResultsBaseUrl = 'https://www.zillow.com/rental-manager/price-my-rental/results/';

const Comps = (props) => {
    const dispatch = useDispatch();

    const { listingCompsModel, status } = props;
    const { floorplans, similarFloorplans } = listingCompsModel;

    const {
        floorplans: compFloorplans,
        highestPriceIncluded,
        lowestPriceIncluded,
    } = similarFloorplans;

    const { address } = floorplans[0];

    const {
        street,
        city,
        state,
        zip,
    } = address;

    const compsFound = compFloorplans.length;

    // comps summary
    const contentComps = `${compsFound} comparable properties`;
    const contentSummary = `listed nearby for $${lowestPriceIncluded} - $${highestPriceIncluded}`;
    const { formattedKebobCase: pmrResultsAddress } = propertyUtils.formatAddress({
        city,
        state,
        street,
        zip,
    });
    const pmrResultsLink = `${pmrResultsBaseUrl}${pmrResultsAddress}/`;

    const handleCompareToMyPropertyClick = () => {
        const { VIEW_COMPARABLES_CLICK } = GA_EVENTS;
        const { VIEW_COMPARABLES } = GA_PREFIX;

        dispatch(analyticsUtils.track.GAEventV2({
            ...VIEW_COMPARABLES_CLICK,
            action: `${VIEW_COMPARABLES}${DELIMITER}${stringHelper.startCaseRemoveSpace(status)}`,
        }));
    };

    const renderCompsSummary = () => (
        <StyledCompsSummaryContainer>
            <StyledText
                as="div"
                fontType="bodyHeading"
            >
                {contentComps}
            </StyledText>

            <StyledText
                as="div"
                fontType="body"
            >
                {contentSummary}
            </StyledText>
        </StyledCompsSummaryContainer>
    );

    return (
        <StyledCompsComponent className="Comps">
            {renderCompsSummary()}

            <StyledTextButton
                forwardedAs="a"
                fontType="body"
                href={pmrResultsLink}
                target="_blank"
                onClick={handleCompareToMyPropertyClick}
            >
                <span className="TextButton-Content">Compare to my property</span>
                <span className="TextButton-Icon"><IconExternal /></span>
            </StyledTextButton>
        </StyledCompsComponent>
    );
};

Comps.propTypes = {
    listingCompsModel: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
};

Comps.defaultProps = {};

export default Comps;
